import { render, staticRenderFns } from "./received-order-edit.vue?vue&type=template&id=5c0cabfd&scoped=true&"
import script from "./received-order-edit.vue?vue&type=script&lang=js&"
export * from "./received-order-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0cabfd",
  null
  
)

export default component.exports